module.exports = __webpack_public_path__ + "img/smart-dental-vision.e3859412.png";